import { InventoryItem } from "../types/inventory";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ItemForm } from "./ItemForm";

interface EditItemDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  item: InventoryItem | null;
  onSave?: (item: Partial<InventoryItem>) => void;
}

export function EditItemDialog({ open, onOpenChange, item, onSave }: EditItemDialogProps) {
  const handleSubmit = (data: any) => {
    onSave?.({
      ...data,
      id: item?.id, // Preserve the item ID
    });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Edit Item</DialogTitle>
        </DialogHeader>

        <ItemForm
          defaultValues={item || undefined}
          onSubmit={handleSubmit}
          onCancel={() => onOpenChange(false)}
          submitLabel="Save Changes"
        />
      </DialogContent>
    </Dialog>
  );
}
